import { render, staticRenderFns } from "./CorporateEmail.vue?vue&type=template&id=56b96f8a&scoped=true"
import script from "./CorporateEmail.vue?vue&type=script&lang=js"
export * from "./CorporateEmail.vue?vue&type=script&lang=js"
import style0 from "./CorporateEmail.vue?vue&type=style&index=0&id=56b96f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b96f8a",
  null
  
)

export default component.exports